// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"aa322d78","455":"59168a5d","593":"8120c84f","748":"ff6bcfbe"}[chunkId] + ".chunk.js";
};